import { useQuery } from '@tanstack/react-query';

import { PricingPlanTier } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/pricing/pricing-plan/:planId/pricing-plan-tier/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    planId: string;
    parkingId: string;
}

const queryFn = ({ planId, parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<PricingPlanTier>> => {
    return axios.get(formatResourcePath(RESOURCE, { planId, parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_PRICING_PLAN_TIERS_RESOURCE, useQueryHook as useListPricingPlanTiers };
